<div #myField (click)="onFieldSelected()" class="myField {{highlight}}" [ngClass]="{
    'highlight': active,
    'd-inline-block': !show.label && options?.displayType !== 'map',
	'd-block': (show.value && options?.cssClass !== 'd-inline-block') || options?.displayType === 'map',
	'canSelectField': fieldHasRule()
  }">

  <h6 *ngIf="show?.label === true">{{options?.label || field?.UILabel || field?.DisplayText || 'No title'}}</h6>

  <div *ngIf="options?.displayType === 'map' && show.value" class="map-view">
    <cv-component-map [mapConfiguration]="mapConfiguration" [zoom]="15" [height]="'300px'">
    </cv-component-map>
  </div>

  <div *ngIf="options?.displayType !== 'map' && show.value">
    <p [ngClass]="options?.cssClass" [ngSwitch]="options?.displayType">
      <span *ngIf="iconExist">
        <i class="{{icons[icon]}}"></i>
      </span>
      <span *ngSwitchCase="'bool'">
        <span *ngIf="value==='Y' || value === 'True'"><i class="fa fa-check"></i>Yes</span>
        <span *ngIf="value==='N' || value === 'False'"><i class="fa fa-times"></i>No</span>
        <span *ngIf="['--',''].indexOf(value) > -1">--</span>
      </span>

      <span *ngSwitchCase="'currency'">{{isNumber(value) ? (parseNumeric(value) | currency): value || '--'}}</span>
      <span *ngSwitchCase="'thousands-currency'">{{isNumber(value) ? ((parseNumeric(value) * 1000) | currency): value ||
        '--'}}</span>
      <span *ngSwitchCase="'gla'">{{isNumber(value) ? (value | number): value}} Sq. Ft.</span>
      <span *ngSwitchCase="'years'">{{isNumber(value) ? (value | number): value}} years</span>
      <span *ngSwitchCase="'percentage'">{{value}} %</span>

      <span *ngSwitchDefault>{{value || '--'}}</span>
    </p>

    <div>
      <button #changesEl *ngIf="historical.length" class="btn btn-sm cv-btn-revised_fields"
        (click)="historicalVal(historical)">
        <i class="fas fa-book"></i>
        <span>{{ historical.length }}</span>
      </button>
    </div>
    <div *ngIf="value && value.length === 4000">
      <p class="messageTooLong">There is more commentary, please see the <a
          [routerLink]="['/intelligence/quality/pdfreview/' + orderId]">PDF</a>.</p>
    </div>
  </div>
</div>